import { ArrowBack } from "@mui/icons-material";
import { Box, Button, CircularProgress, Stack } from "@mui/material";
import { useHistory } from "react-router-dom";
import { useUnitListStore } from "../UnitList/useUnitListStore";
import { ActivityListCard } from "./ActivityListCard";
import { LeaseMetadataCard } from "./LeaseMetadataCard";
import { useQuery } from "@apollo/client";
import { getRelationship, getLocation } from "../../queries";

type SelectedLeaseDetailsProps = {};

function SelectedLeaseDetails({}: SelectedLeaseDetailsProps) {
  const { selectedLocationId, selectedRelationshipId } = useUnitListStore((state) => ({
    selectedLocationId: state.selectedLocationId,
    selectedRelationshipId: state.selectedRelationshipId,
  }));
  const history = useHistory();

  const { data: relationship, loading: relationshipLoading } = useQuery(getRelationship, {
    variables: {
      id: selectedRelationshipId,
    },
    skip: !selectedRelationshipId,
  });

  const { data: location, loading: locationLoading } = useQuery(getLocation, {
    variables: {
      locationId: selectedLocationId,
    },
    skip: !selectedLocationId,
  });

  if (relationshipLoading || locationLoading) {
    return <CircularProgress />;
  }

  return (
    <Stack flex={1} overflow={"auto"} spacing={1.5}>
      <Box>
        <Button color="navy" onClick={() => history.goBack()} startIcon={<ArrowBack />}>
          {/* If this page is navigated from the unit list page, show the portfolio and facility name. Otherwise, if this page is navigated to from just the url, we don't have state for the unit list page and should just show "Back" */}
          {relationship && location ? `${relationship.getRelationship.name} / ${location.getLocation.fullAddress}` : "Back"}
        </Button>
      </Box>
      <Stack direction={"row"} spacing={2} flex={1}>
        <Box sx={{ flex: 1 }}>
          <LeaseMetadataCard />
        </Box>
        <Box sx={{ flex: 1 }}>
          <ActivityListCard />
        </Box>
      </Stack>
    </Stack>
  );
}

export { SelectedLeaseDetails };
